import { VStack } from '@chakra-ui/react';
import React from 'react';

import { InvoiceFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { colors } from 'packages/common-frontend/colors';
import { InvoiceDisbursements } from 'packages/invoices/ui/disbursements/InvoiceDisbursements';
import { InvoicePaymentInKindItems } from 'packages/invoices/ui/paymentInKind/InvoicePaymentInKindItems';

export const InvoiceDetailDisbursementAndPaymentInKind = ({
  invoice,
}: {
  invoice: InvoiceFragmentGQLType;
}) => {
  return (
    <VStack
      align="flex-start"
      gap="40px"
      p="40px"
      borderRadius="8px"
      borderColor={colors.gray[100]}
      borderWidth="1px"
      width="100%"
    >
      <InvoiceDisbursements invoice={invoice} />
      <InvoicePaymentInKindItems invoice={invoice} />
    </VStack>
  );
};
